import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import selectComp from './select.vue';
export default {
  meta: {
    title: '销售属性',
    auth: true,
    authorityValue: "store-goods-sellatt"
  },
  name: 'saleAttrs',
  components: {
    selectComp: selectComp
  },
  data: function data() {
    return {
      tableData: [],
      total: 0
    };
  },
  methods: {
    selectCompChange: function selectCompChange(e) {
      console.log('e', e);
      var length = e.length;
      this.dataBind({
        goodsTypeId: e[length - 1]
      });
      return;

      if (e.length == 3) {
        this.dataBind({
          goodsTypeId: e[length - 1]
        });
      }
    },
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$$api$sel, records, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.sellAttributes(_objectSpread({}, item));

              case 2:
                _yield$_this$$api$sel = _context.sent;
                records = _yield$_this$$api$sel.records;
                total = _yield$_this$$api$sel.total;
                _this.total = total;
                _this.tableData = records;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    pagination: function pagination(e) {
      this.dataBind(e);
    },
    handleNav: function handleNav(NAME, row) {
      this.$router.push({
        name: NAME,
        query: row ? row : ''
      });
    }
  }
};